import { request } from './api';

import * as Alert from './alert';

/**
 * Action constants
 */
export const ETFAGENT_REQUEST = 'ETFAGENT_REQUEST';
export const ETFAGENT_SIMILARITY_SEARCH_SUCCESS =
  'ETFAGENT_SIMILARITY_SEARCH_SUCCESS';
export const ETFAGENT_CATEGORY_SEARCH_SUCCESS =
  'ETFAGENT_CATEGORY_SEARCH_SUCCESS';
export const ETFAGENT_REQUEST_FAILURE = 'ETFAGENT_REQUEST_FAILURE';
export const ETFAGENT_CLEAR_RESULTS = 'ETFAGENT_CLEAR_RESULTS';
export const ETFAGENT_UPDATE_FIELD = 'ETFAGENT_UPDATE_FIELD';
export const ETFAGENT_SEARCH_SUCCESS = 'ETFAGENT_SEARCH_SUCCESS';
export const ETFAGENT_ADD_SELECTED_TICKER = 'ETFAGENT_ADD_SELECTED_TICKER';
export const ETFAGENT_REMOVE_SELECTED_TICKER =
  'ETFAGENT_REMOVE_SELECTED_TICKER';

/**
 * Action creators
 */

export function similaritySearch(ticker) {
  return (dispatch) => {
    dispatch({ type: ETFAGENT_REQUEST });
    return dispatch(request('get', `/aitools/etf-screener/${ticker}/`)).then(
      (data) =>
        dispatch({
          type: ETFAGENT_SIMILARITY_SEARCH_SUCCESS,
          target: data.target,
          matches: data.matches,
          responseID: data.response_id,
        }),
      (error) => {
        dispatch({ type: ETFAGENT_REQUEST_FAILURE });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}

export function categorySearch(query) {
  return (dispatch) => {
    dispatch({ type: ETFAGENT_REQUEST });

    return dispatch(
      request('post', `/aitools/etf-query/`, { body: { query } })
    ).then(
      (data) =>
        dispatch({
          type: ETFAGENT_CATEGORY_SEARCH_SUCCESS,
          results: data,
        }),
      (error) => {
        dispatch({ type: ETFAGENT_REQUEST_FAILURE });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}

export function add(id) {
  return (dispatch) => dispatch(similaritySearch(id));
}
export function search(id, types = []) {
  return (dispatch) =>
    dispatch(
      request(
        'get',
        `/security/search?term=${id}${types
          .map((type) => `&type=${type}`)
          .join('')}`
      )
    ).then(
      (data) => dispatch({ type: ETFAGENT_SEARCH_SUCCESS, data }),
      (error) => {
        dispatch({ type: ETFAGENT_SEARCH_SUCCESS, data: [] });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
}

export function updateField(field, value) {
  return {
    type: ETFAGENT_UPDATE_FIELD,
    field,
    value,
  };
}

export function addSelectedTicker(ticker) {
  return {
    type: ETFAGENT_ADD_SELECTED_TICKER,
    ticker,
  };
}

export function removeSelectedTicker(ticker) {
  return {
    type: ETFAGENT_REMOVE_SELECTED_TICKER,
    ticker,
  };
}

export function clearResults() {
  return { type: ETFAGENT_CLEAR_RESULTS };
}

/**
 * Helper Functions
 */
function parseErr(err) {
  if (err.non_field_errors) {
    return err.non_field_errors[0];
  }

  return err.msg || err.detail || 'Server Offline';
}
